import type { TranslationKey } from '@/common/types';

const positionTranslationMap: Record<string, TranslationKey> = {
  goalkeeper: 'PreMatchStats.Goalkeeper',
  defender: 'PreMatchStats.Defender',
  midfielder: 'PreMatchStats.Midfielder',
  forward: 'PreMatchStats.Forward',
  winger: 'PreMatchStats.Winger',
  striker: 'PreMatchStats.Striker',
  sweeper: 'PreMatchStats.Sweeper',
};

export default positionTranslationMap;
